export default __webpack_public_path__ + "static/media/jordan.be4c8738.jpg";